import React from "react";
import { Grid,Box,Tab } from "@mui/material";
import {TabContext,TabList,TabPanel} from "@mui/lab";
import Loader from "components/loader/Loader";
import FaqCustomerAccordian from "./FaqCustomerAccordian";

function FaqTabSection(props) {
  const { accordianData, handleChange, value, faqSectionLoader } = props;
  return (
    <Grid container>
      <Grid item className="tabContainer" xs={12}>
        <Box className="contentBoxStyle marginBlock10">
          <TabContext value={value}>
            <Grid
              container
              className="tabBoxStyle mt10"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item>
                <TabList
                  className="minHeight32"
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                  xs={6}
                >
                  <Tab label="Customer" value="Customer" className="tabStyle" />
                  <Tab label="Driver" value="Driver" className="tabStyle" />
                </TabList>
              </Grid>
            </Grid>
            <TabPanel value="Customer" className="tabPanelStyle">
              {faqSectionLoader ? (
                <Loader />
              ) : (
                <FaqCustomerAccordian accordianData={accordianData} value={value}/>
              )}
            </TabPanel>
            <TabPanel value="Driver" className="tabPanelStyle">
              {faqSectionLoader ? (
                <Loader />
              ) : (
                <FaqCustomerAccordian accordianData={accordianData} value={value} />
              )}
            </TabPanel>
          </TabContext>
        </Box>
      </Grid>
    </Grid>
  );
}

export default FaqTabSection;
